export const DETAIL_COVERS = [
  "/images/cover.png",
  "/images/cover_1.png",
  "/images/cover_2.png",
];

export function detailCoverForKey(key = "") {
  const value = String(key || "default");
  let hash = 0;

  for (let i = 0; i < value.length; i += 1) {
    hash = (hash + value.charCodeAt(i) * (i + 1)) % DETAIL_COVERS.length;
  }

  return DETAIL_COVERS[hash];
}
